export default "/images/5d83657bd8c06d175e1dae046a0915e7.avif";